<template>
  <base-modal :body_class="['pb-0']">
    <number-create-form ref="form" />
    <i-button
      slot="footer-ok"
      size="large"
      type="success"
      :loading="is_loading"
      :disabled="is_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import NumberCreateForm from '@pbx/components/numbers/form/create';

  export default {
    components: {
      BaseModal,
      NumberCreateForm
    },

    data: () => ({
      is_loading: false
    }),

    methods: {
      save: function () {
        const form = this.$refs.form;

        form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_loading = true;
            this.$refs.form
              .send()
              .then((res) => this.$emit('success', res))
              .catch((e) => {
                this.$noty.server_error(e);
                this.is_loading = false;
              });
          }
        });
      }
    }
  };
</script>
